import { Box, MenuItem, Paper, TextField, Typography } from '@mui/material';
import { Field } from 'formik';
import React from 'react';
import MultipleSelectChip from './MultipleSelectChip';
import { fluency } from '../util/fluency';
import RadioYN from './RadioYN';
import { screenTime } from '../util/screenTime';
import { genders } from '../util/genders';
export default function AcademicLearningDetailsSection({ touched, values, setFieldValue, errors }) {
  const preference = [
    ...genders,
    {
      id: 3,
      name: 'No preference',
    },
  ];

  return (
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" mb={6}>
        Academic & Learning Details
      </Typography>
      <Box display={'flex'} gap={2} flexDirection={'column'} maxWidth={900}>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            select
            fullWidth
            id="trainerPreference"
            label="Trainer Preference"
            name="trainerPreference"
            error={touched.trainerPreference && Boolean(errors.trainerPreference)}
            helperText={touched.trainerPreference && errors.trainerPreference}
            onChange={({ target }) => setFieldValue(target.name, target.value)}
          >
            {preference.map((e) => (
              <MenuItem key={e?.id} value={e?.name}>
                {e.name}
              </MenuItem>
            ))}
          </Field>
          <MultipleSelectChip
            lists={fluency}
            label={'Language Fluency'}
            initVal={values?.languageFluency}
            changeHandler={(v) => setFieldValue('languageFluency', v)}
            fullWidth
            error={touched.languageFluency && Boolean(errors.languageFluency)}
            helperText={touched.languageFluency && errors.languageFluency}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          {/* <Field
            as={TextField}
            label="Attendance Percentage"
            name="attendance"
            type="number"
            InputProps={{
              endAdornment: '%',
            }}
            fullWidth
          /> */}
          <Field
            as={TextField}
            label="Average Screen Time"
            select
            name="averageScreenTime"
            sx={{ maxWidth: 400 }}
            fullWidth
            onChange={({ target }) => setFieldValue(target.name, target.value)}
          >
            {screenTime.map((e, i) => (
              <MenuItem key={i} value={e?.name}>
                {e?.name}
              </MenuItem>
            ))}
          </Field>
        </Box>
        <RadioYN
          sx={{
            width: { xs: '100%', sm: 250 },
          }}
          onChange={(v) => setFieldValue('internetType', v)}
          label={'Internet Type'}
          valueKey={'label'}
          value={values?.internetType}
          data={[
            { label: 'Wifi', value: 0 },
            { label: 'Mobile Data', value: 1 },
          ]}
        />
      </Box>
    </Paper>
  );
}
